import { useTenantProfileQuery } from '../../../features/tenant/queries/useTenantProfileQuery';
import { useI18n } from '../../../i18n/useI18n';
import { TenantDetailsForm } from '../TenantDetailsForm';
import './TenantTab.css';

export function TenantTab() {
  const { translate } = useI18n();
  const profileQuery = useTenantProfileQuery();
  const tenant = profileQuery.data;

  if (profileQuery.isLoading) {
    return (
      <p className="tenant-tab__status">
        {translate('organisationManagement.organisation.loading')}
      </p>
    );
  }

  if (profileQuery.isError || !tenant) {
    return (
      <p className="tenant-tab__status" role="alert">
        {translate('organisationManagement.organisation.loadError')}
      </p>
    );
  }

  return (
    <TenantDetailsForm
      key={`${tenant.name}:${tenant.version ?? 'unknown'}`}
      tenant={tenant}
    />
  );
}
